import {Box, Flex, Text, Title} from 'exsportia-components'
import {Formik, FormikConfig} from 'formik'
import {FC} from 'react'
import {object} from 'yup'

import {Button} from '../../ui/components/button/button'
import {Input} from '../../ui/components/input/input'
import {PhoneLoginProgress} from '../../ui/components/phone-login-progress/phone-login-progress'
import {useLocale} from '../../utils/i18n'
import {EMAIL_VALIDATION} from '../../utils/validation'

type PhoneLoginEmailFormType = {
  email: string
}

type PhoneLoginEmailStepProps = {
  onNext: (email: string) => void
  isLoading?: boolean
  error?: string | null
  onBack?: () => void
  initialEmail?: string
}

export const PhoneLoginEmailStep: FC<PhoneLoginEmailStepProps> = ({onNext, onBack, isLoading = false, error, initialEmail}) => {
  const {l} = useLocale()

  const handleSubmit: FormikConfig<PhoneLoginEmailFormType>['onSubmit'] = (values) => {
    onNext(values.email)
  }

  const validationSchema = object().shape({
    email: EMAIL_VALIDATION,
  })

  return (
    <Formik<PhoneLoginEmailFormType>
      initialValues={{email: initialEmail || ''}}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {({handleSubmit: formikSubmit}) => (
        <Box pb={'24px'}>
          <PhoneLoginProgress currentStep={3} />
          <Flex mb='8px'>
            <Title
              text={l('addEmail', {defaultMessage: 'Add your email'})}
              styleType='h2'
            />
          </Flex>
          <Flex mb='16px'>
            <Text text={l('addEmailSubtitle', {defaultMessage: 'For booking confirmations and account recovery'})} />
          </Flex>
          <Input
            id='email'
            placeholder={l('email')}
          />
          {error && (() => {
            let errorText = error
            if (error.toLowerCase().includes('different phone')) {
              errorText = 'This email is already linked to a different phone number. Please use that number or contact support.'
            } else if (error.toLowerCase().includes('already linked')) {
              errorText = 'This email is already registered. Please login with your password instead.'
            }
            return (
              <Box
                mt='5px'
                mb='10px'
                fontSize='12px'
                color='error'
              >
                {errorText}
              </Box>
            )
          })()}
          <Flex mt='16px' gap='16px'>
            {onBack && (
              <Box style={{flex: 1}}>
                <Button
                  type='secondary'
                  onClick={onBack}
                >
                  {l('back', {defaultMessage: 'Back', caseAction: 'capitalize'})}
                </Button>
              </Box>
            )}
            <Box style={{flex: 1}}>
              <Button
                isLoading={isLoading}
                // @ts-ignore
                onClick={formikSubmit}
              >
                {l('next', {defaultMessage: 'Next'})}
              </Button>
            </Box>
          </Flex>
        </Box>
      )}
    </Formik>
  )
}
